import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import { Box } from "@mui/material";

const OTPInputs = ({
  onChange,
  validateForm,
  wrapperProps = {},
}: {
  onChange: any;
  validateForm: any;
  wrapperProps: any;
}) => {
  const [otp, setOtp] = useState("");

  useEffect(() => {
    onChange(otp);
  }, [otp, onChange]);

  return (
    <Box display="flex" justifyContent="center">
      <OtpInput
        value={otp}
        onChange={setOtp}
        numInputs={6}
        renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
        renderInput={(props: any, index: number): any => (
          <input
            {...props}
            className="otp-input"
            style={{
              width: "30%",
              height: 50,
              textAlign: "center",
              border: "none",
              borderBottom: "1px solid black",
              outline: 0,
            }}
            onChange={(e: any) => {
              return [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].includes(
                Number(e.target.value)
              )
                ? props.onChange(e)
                : null;
            }}
            autoFocus={index === 0}
            onKeyPress={validateForm}
            type="text"
          />
        )}
        {...wrapperProps}
      />
    </Box>
  );
};

export default OTPInputs;
